"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// src/jsx/FireFill.tsx
function FireFill(props) {
  return /* @__PURE__ */ React__namespace.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ...props
  }, /* @__PURE__ */ React__namespace.createElement("path", {
    d: "M9.738 2.035a1 1 0 011.006.297c1.665 1.852 2.444 3.564 2.788 5.126.1.45.162.888.2 1.304.498-.726.936-1.496 1.394-2.248a1 1 0 011.36-.388l.415.394C19.268 9.4 20 12.2 20 14.077 20 18.817 16.478 22 12 22s-8-3.184-8-7.923c0-2.422 1.153-4.043 2.247-5.579l.038-.053C7.382 6.903 8.505 5.326 9.02 2.8a1 1 0 01.718-.765z"
  }));
}
var FireFill_default = FireFill;

exports.FireFill_default = FireFill_default;
